if (!customElements.get('up-fake-countdown')) {
  class upFakeCountdown extends HTMLElement {
    constructor() {
      super();

      this.defaultDuration = this.dataset.defaultDuration || 15; // In Min
      this.endTimeMS =
        new Date().getTime() + (parseInt(localStorage.getItem('up_countdown_lp')) || this.defaultDuration * 60 * 1000);
      this.stateName = null;

      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;

      this.state = {
        hours: 0,
        minutes: 0,
        seconds: 0,
      };

      // UI
      this.messages = Array.from(this.querySelectorAll('span[state]'));
      this.countdown = this.querySelector('.announcement-bar__countdown-wrapper');

      this.countdownDigitsUI = {
        hours: this.countdown.querySelector('[data-hours]'),
        minutes: this.countdown.querySelector('[data-minutes]'),
        seconds: this.countdown.querySelector('[data-seconds]'),
      };
    }

    connectedCallback() {
      this.updateComponent();
      this.timer = setInterval(this.updateComponent.bind(this), 1000);
    }

    updateComponent() {
      this.updateState();
      this.saveTimeToStorage();
      if (this.stateName != this.lastStateName) this.updateView();
      if (this.stateName === 'during') this.updateCounterUI();
      if (this.stateName === 'after') {
        localStorage.removeItem('up_countdown_lp');
        clearInterval(this.timer);
      }
    }

    updateState() {
      this.lastStateName = this.stateName;
      this.remainingMS = this.endTimeMS - new Date().getTime();
      if (this.remainingMS > 0) {
        this.state.hours = Math.floor(this.remainingMS / this.hour);
        this.state.minutes = Math.floor((this.remainingMS % this.hour) / this.minute);
        this.state.seconds = Math.floor((this.remainingMS % this.minute) / this.second);
      }
      this.stateName = this.remainingMS > 0 ? 'during' : 'after';
    }

    updateView() {
      // Message
      this.messages.forEach((message) => message.classList.add('hidden'));
      this.messages.find((message) => message.getAttribute('state') === this.stateName).classList.remove('hidden');
      // Coutdown
      this.stateName === 'during' ? this.countdown.classList.remove('hidden') : this.countdown.classList.add('hidden');
    }

    updateCounterUI() {
      if (this.countdownDigitsUI.hours)
        this.countdownDigitsUI.hours.innerText = String(this.state.hours).padStart(2, '0');
      this.countdownDigitsUI.minutes.innerText = String(this.state.minutes).padStart(2, '0');
      this.countdownDigitsUI.seconds.innerText = String(this.state.seconds).padStart(2, '0');
    }

    saveTimeToStorage() {
      if (this.state.seconds % 10 === 0) {
        localStorage.setItem('up_countdown_lp', this.remainingMS);
      }
    }
  }
  customElements.define('up-fake-countdown', upFakeCountdown);
}
